<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="fa ti-briefcase"></i> {{ $t('company') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="box_infos_right">
            <div class="box_contents">
                <pml-avatar></pml-avatar>
                <ul class="nav nav-tabs menu_deals menu_vertical">
                    <router-link tag="li" :to="{ name: 'company.info' }">
                        <a><i class="ti-briefcase"></i><b>{{ $t('company_info') }}</b></a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'company.members' }">
                        <a><i class="icon-people"></i><b>{{ $t('users') }}</b></a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'company.billing' }">
                        <a><i class="ti-marker-alt"></i><b>{{ $t('subscription') }}</b></a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'company.additional-information' }">
                        <a><i class="ti-comment"></i><b>{{ $t('quote_additional_info') }}</b></a>
                    </router-link>
                    <router-link tag="li" :to="{ name: 'company.webhook' }">
                        <a><i class="fa fa-cogs"></i><b>{{ $t('webhook') }}</b></a>
                    </router-link>
                </ul>
            </div>
            <div class="box_contents">
                <div class="card-box p-0 search-result-box">
                    <div class="tab-content p-0">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import PmlAvatar from './Avatar.vue'
    import { mapGetters } from 'vuex'

    export default {
        name: 'Company',
        metaInfo () {
            return {
                title: this.company.fancy_name
            }
        },
        components: { PmlAvatar },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'company': 'getCompany'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/Main.vue